import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

import { WrapperConfig } from './wrapperDecorator'
import { WidgetPage } from './types'

import './modal.scss'
import CardEditor from '../../../common/components/CardEditor'
import { WidgetTypes } from '../../../common/types/api/report'

interface Props {
    wrapper: WrapperConfig
    content: WidgetPage
    editMode: boolean
    openEditor: boolean
    onChange: (widget: WidgetPage) => void
    setOpenEditor: () => void
    setCloseEditor: () => void
}

export default function Wrapper({
    wrapper,
    content,
    editMode,
    onChange,
    openEditor: showEditor,
    setOpenEditor,
    setCloseEditor
}: Props): JSX.Element {
    const [draftContent, setDraftContent] = useState<WidgetPage>(content)
    const [selectedConfigProps, setConfigProps] = useState()
    const { Preview, minHeight, Editor, type } = wrapper
    const { config } = draftContent

    const [subContentType , setSubContentType] = useState()

    useEffect(() => {
        setDraftContent(content)
    }, [content])

    return (
        <Content
            style={{ minHeight }}
        >
            <Preview
                {...content.config}
                openEditor={selected => {                    
                    if (editMode && !showEditor) {
                        if(selected?.subContentType) 
                            setSubContentType(selected.subContentType)
                        setOpenEditor()
                        if(selected)
                            setConfigProps(selected)
                    }
                }}
                onChange={onChange}
                editMode={editMode}
            />
            <Modal
                show={showEditor && editMode}
                size="lg"
                onHide={() => {
                    setCloseEditor()
                }}
                aria-labelledby="contained-modal-title-vcenter"
                className="report-widget-edit-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: 'none' }}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {type === 'html' ? (
                            <b>Add Text</b>
                        ) : type === 'pipes' ? (
                            <b>Add HTML Component</b>
                        ) : (
                            <b>Import widget</b>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 0, border: 0 }}>
                    <CardEditor<WidgetPage, WidgetPage>
                        hideHeader={true}
                        variant={'secondary'}
                        title={''}
                        defaultEditMode={true}
                        FormComponent={(type != WidgetTypes.GALLERY)? Editor : Editor(subContentType)}
                        formObject={{...draftContent, configProps: selectedConfigProps}}
                        onChange={setDraftContent}
                        onSave={newContent =>
                            new Promise(resolve => {
                                onChange(newContent)
                                setTimeout(() => {
                                    setCloseEditor()
                                    resolve(newContent)
                                }, 100)
                            })
                        }
                        onCancel={() => {
                            setCloseEditor()
                        }}
                    ></CardEditor>
                </Modal.Body>
            </Modal>
        </Content>
    )
}

const Content = styled.div`
    padding: 0px;
`
